module.exports = __webpack_public_path__ + "img/3-4.5489d693.gif";